import {
  TbChecklist,
  TbHome,
  TbListDetails,
  TbPlus,
  TbRvTruck,
  TbTruck,
  TbUsers,
  TbUsersGroup,
  TbCash,
  TbCashBanknote,
  TbCashBanknotePlus,
  TbCashBanknoteFilled,
  TbBuildingWarehouse,
  TbX,
} from "react-icons/tb";
import SidebarLink from "./SidebarLink";
import GroupedSidebarLink from "./GroupedSidebarLink";
import { useLocation } from "react-router-dom";
import { useState, useEffect } from "react";

// Função para decodificar JWT
const decodeJWT = (token) => {
  try {
    const payload = token.split('.')[1];
    const decodedPayload = atob(payload);
    return JSON.parse(decodedPayload);
  } catch (error) {
    console.error('Erro ao decodificar JWT:', error);
    return null;
  }
};

const Sidebar = ({ isOpen, toggleSidebar }) => {
  const location = useLocation();
  const [userRoleId, setUserRoleId] = useState(null);
  const [userId, setUserId] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      const decodedData = decodeJWT(token);

      if (decodedData) {
        // user_role_id
        if (decodedData.user_role_id) {
          setUserRoleId(decodedData.user_role_id);
          window.userRoleId = decodedData.user_role_id; // Para acesso global
        }

        // user id (pode variar conforme como seu backend assina o token)
        const extractedUserId =
          decodedData.user_id ??
          decodedData.id ??
          decodedData.sub ??
          null;

        if (extractedUserId !== null && extractedUserId !== undefined) {
          const numericUserId = Number(extractedUserId);
          setUserId(Number.isNaN(numericUserId) ? null : numericUserId);
          window.userId = Number.isNaN(numericUserId) ? null : numericUserId; // opcional: acesso global
        }
      }
    }
  }, []);

  // Permissões baseadas no user_role_id
  const canAccessLoad = [1, 2, 3, 4, 7].includes(userRoleId);
  const canAccessCreateLoad = [1, 2, 4, 7].includes(userRoleId);
  const canAccessQuotes = [1, 4, 7].includes(userRoleId);
  const canAccessStaff = [1, 4, 7].includes(userRoleId);
  const canAccessShipper = [1, 4, 7].includes(userRoleId);
  const canAccessLandingPage = [1, 4].includes(userRoleId);
  const canAccessFactoring = [1, 4].includes(userRoleId);
  const canAccessMaintenance = [1, 4].includes(userRoleId);
  const canAccessLead = [1, 4].includes(userRoleId);
  const canAccessCarrierLead = [1, 4].includes(userRoleId);
  const canAccessFinance = [1, 2, 3, 4, 5, 6, 7].includes(userRoleId);

  // ✅ whitelist de usuários que podem ver o menu /shippermanagement
  const allowedShipperManagementUserIds = [1, 2, 5, 61, 62, 96, 115, 173, 221, 256];
  const allowedLandingPageManagementUserIds = [1, 2, 5, 61, 62, 96, 115, 173, 221, 256, 293, 320, 321, 322];

  const allowedMaintenanceUserIds = [1, 2, 5, 61, 62, 96, 115, 173, 221, 256]; // Não alterar. Risco de violação de segurança entre Companies.

  const allowedFactoringUserIds = [1, 2, 5, 31, 61, 62, 96, 115, 173, 221, 256, 293, 320, 321, 322];
  const allowedFinanceUserIds = [1, 2, 5, 31, 61, 62, 96, 115, 173, 221, 256, 293, 320, 321, 322]; // Adicionado 320- Gilberto (gilbertomdca@gmail.com)
  const allowedLeadUserIds = [1, 2, 5, 31, 61, 62, 96, 115, 173, 221, 256, 293];
  const allowedCarrierLeadUserIds = [1, 2, 5, 31, 61, 62, 96, 115, 173, 221, 256, 293];

  // const allowedFactoringUserIds = [1, 2, 5, 61, 62, 96, 115, 173, 221, 256, 293];

  const canSeeShipperManagementMenu =
    allowedShipperManagementUserIds.includes(userId);
  const canSeeLandingPageManagementMenu =
    allowedLandingPageManagementUserIds.includes(userId);
  const canSeeMaintenanceMenu =
    allowedMaintenanceUserIds.includes(userId);
  const canSeeFactoringMenu =
    allowedFactoringUserIds.includes(userId);
  const canSeeFinanceMenu =
    allowedFinanceUserIds.includes(userId);
  const canSeeLeadMenu =
    allowedLeadUserIds.includes(userId);
  const canSeeCarrierLeadMenu =
    allowedCarrierLeadUserIds.includes(userId);

  return (
    <aside
      className={`w-60 sm:w-20 sm:hover:w-60 z-50 fixed left-0 top-0 bottom-0 h-screen max-h-screen bg-[#1c1b19] border-r border-zinc-700 shadow-lg shadow-black/[0.07]
      transition-all duration-300 ease-in-out overflow-hidden flex flex-col
      ${isOpen ? "translate-x-0 sm:w-60" : "-translate-x-full sm:translate-x-0"}`}
    >
      <div className="flex justify-between items-center py-2.5 px-4 flex-shrink-0">
        <img
          src="/img/cajuu_logo.png"
          alt="Logo"
          className="max-w-[5rem] w-[3rem] sm:hover:w-[5rem] transition-all duration-200"
        />
        <button className="text-white sm:hidden" onClick={toggleSidebar}>
          <TbX size={24} />
        </button>
      </div>

      <nav className="pt-8 pb-6 flex-1 min-h-0 overflow-y-auto overflow-x-hidden overscroll-contain">
        <SidebarLink link="/Dashboard" Icon={TbHome} text="Dashboard" isOpen={isOpen} />

        {canAccessLoad && (
          <GroupedSidebarLink
            icon={TbTruck}
            text="Load"
            isOpen={isOpen}
            links={[
              { link: "/Load", Icon: TbRvTruck, text: "All Loads" },
              ...(canAccessCreateLoad
                ? [{ link: "/NewLoad", Icon: TbPlus, text: "Create Load" }]
                : []
              )
            ]}
          />
        )}

        {canAccessQuotes && (
          <GroupedSidebarLink
            icon={TbChecklist}
            text="Quote"
            isOpen={isOpen}
            links={[
              { link: "/Quotes", Icon: TbListDetails, text: "All Quotes" },
              { link: "/NewQuotes", Icon: TbCashBanknoteFilled, text: "Create Quote" },
            ]}
          />
        )}

        {canAccessStaff && (
          <SidebarLink
            link="/StaffManagement"
            Icon={TbUsersGroup}
            text="Employees"
            isOpen={isOpen}
          />
        )}

        {/* ✅ Só mostra para IDs específicos */}
        {canAccessShipper && canSeeShipperManagementMenu && (
          <SidebarLink
            link="/shippermanagement"
            Icon={TbBuildingWarehouse}
            text="Shippers"
            isOpen={isOpen}
          />
        )}

        {canAccessLandingPage && canSeeLandingPageManagementMenu && (
          <GroupedSidebarLink
            icon={TbChecklist}
            text="Company"
            isOpen={isOpen}
            links={[
              { link: "/companymanagement", Icon: TbListDetails, text: "Company Data" },
              { link: "/landingpagemanagement", Icon: TbChecklist, text: "Landing Page Data" },
            ]}
          />
        )}

        {canAccessFactoring && canSeeFactoringMenu && (
          <SidebarLink
            link="/Factoring"
            Icon={TbCash}
            text="Factoring"
            isOpen={isOpen}
          />
        )}

        {canAccessLead && canSeeLeadMenu && (
          <GroupedSidebarLink
            icon={TbUsersGroup}
            text="Lead"
            isOpen={isOpen}
            links={[
              { link: "/lead", Icon: TbChecklist, text: "Lead Shipper" },
              { link: "/carrier-leads", Icon: TbTruck, text: "Lead Carrier" },
            ]}
          />
        )}

        {/* {canAccessFinance && ( */}
        {/* ✅ Só mostra para IDs específicos */}
        {canAccessFinance && canSeeFinanceMenu && (
          <GroupedSidebarLink
            icon={TbCash}
            text="Finance"
            isOpen={isOpen}
            links={[
              { link: "/ExternalLoad", Icon: TbCashBanknote, text: "All External Loads" },
              { link: "/NewExternalLoad", Icon: TbPlus, text: "Create External Load" },
              { link: "/Expense", Icon: TbCashBanknote, text: "All Expenses" },
              { link: "/NewExpense", Icon: TbPlus, text: "Create Expense" },
              { link: "/Report", Icon: TbCashBanknote, text: "Report" }
            ]}
          />

        )}

        {/* ✅ Só mostra para IDs específicos */}
        {canAccessMaintenance && canSeeMaintenanceMenu && (
          <GroupedSidebarLink
            icon={TbListDetails}
            text="Maintenance"
            isOpen={isOpen}
            links={[
              { link: "/InspectionPhotoHierarchy", Icon: TbChecklist, text: "Inspection Photos" },
              { link: "/UserAccessLogs", Icon: TbUsers, text: "User Access Logs" },
              { link: "/LoadTransportMaintenance", Icon: TbTruck, text: "Load Transports" },
            ]}
          />
        )}

      </nav>
    </aside>
  );
};

export default Sidebar;
